// extracted by mini-css-extract-plugin
export var addButton = "_gf-0";
export var border = "_gf-8";
export var check = "_gf-h";
export var danger = "_gf-6";
export var dropdownContainer = "_gf-1";
export var editModalBody = "_gf-j";
export var footerContainer = "_gf-i";
export var fullWidth = "_gf-a";
export var hide = "_gf-9";
export var icon = "_gf-3";
export var input = "_gf-7";
export var inputFlex = "_gf-b";
export var inputWrapper = "_gf-c";
export var manualFocus = "_gf-5";
export var optionButton = "_gf-4";
export var pillWrapper = "_gf-e";
export var pointer = "_gf-2";
export var showOverflow = "_gf-f";
export var tagsFlex = "_gf-d";
export var xButton = "_gf-g";